import React from "react";
import VideoJS from "./VideoJS";
import {Card, Col, Row} from "antd";
import {CloseOutlined} from "@ant-design/icons";

const DefaultVideoCard = ({src, title, closable = false, onClickClose}) => {
    const playerRef = React.useRef(null);

    const videoJsOptions = { // lookup the options in the docs for more options
        autoplay: true,
        controls: true,
        responsive: true,
        liveui: true,
        normalizeAutoplay: true,
        fluid: true,
        sources: [{
            src: src,
        }]
    }

    const handlePlayerReady = (player) => {
        playerRef.current = player;
        player.on('waiting', () => {
        });

        player.on('ready', () => {
        })

        player.on('dispose', () => {
        });
    };

    return (
        <Card size='small' style={{height: '100%'}}>
            <VideoJS options={videoJsOptions} onReady={handlePlayerReady}/>
            <Row justify={'space-between'}>
                <Col>
                    {title}
                </Col>
                {
                    closable && <Col>
                        <span style={{cursor: 'pointer'}}
                              onClick={() => onClickClose && onClickClose()}><CloseOutlined/></span>
                    </Col>
                }
            </Row>
        </Card>
    )
}

export default DefaultVideoCard